import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import RichTable from '../components/richTable/RichTable.jsx'
import tableHelpers from '../helpers/TableHelpers.js'
import Tooltip from '../components/Tooltip.js';
import SingleAlgoRobustness from './SingleAlgoRobustness.js';
import AlgoStatsTooltip from '../components/AlgoStatsTooltip.js'
import AlgoDrawer from '../algos/AlgoDrawer.js'
import AlgoQuickManage from '../manage/AlgoQuickManage.js';

function AlgoRobustness(props) {
    const [data, setData] = useState([]);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        (function () {
            fetch(`/api/planRobustness?planId=` + props.planId + (showAll ? "&showAll=1" : ""))
                .then(res => res.json())
                .then(text => {
                    console.log("planRobustness", text);
                    setData(text);
                });
        })();
    }, [props.planId, showAll]);

    function getSccores() {
        return data;
    }

    function getStats() {
        let results = { totalScore: 0, count: 0, totalWeightedScore: 0, totalLong: 0, totalShort: 0, longCount: 0, shortCount: 0, average: 0, weightedAverage: 0, totalWeights: 0, longAverage: 0, shortAverage: 0, totalZscore: 0, oosAverage: 0, paramSensAverage: 0, liveVsBacktestAverage: 0, live_vs_backtest: 0 };
        let zScoreCount = 0;
        let totalOos = 0;
        let oosCount = 0;
        let totalParamSens = 0;
        let paramSensCount = 0;
        let totalLiveVsBacktest = 0;
        let liveVsBacktestCount = 0;

        data.forEach(s => {
            let avg = s.overall;
            results.totalScore += avg;
            results.totalWeightedScore += avg * s.percentage;
            results.totalWeights += s.percentage;
            if (s.z_score != null) {
                results.totalZscore += s.z_score;
                zScoreCount++;
            }
            if (s.live_vs_backtest != null && !isNaN(Number(s.live_vs_backtest))) {
                totalLiveVsBacktest += Number(s.live_vs_backtest);
                liveVsBacktestCount++;
            }
            if (s.oos != null && !isNaN(Number(s.oos))) {
                totalOos += Number(s.oos);
                oosCount++;
            }
            if (s.parameter_sensitivity != null && !isNaN(Number(s.parameter_sensitivity))) {
                totalParamSens += Number(s.parameter_sensitivity);
                paramSensCount++;
            }
            if (s.short) {
                results.totalShort += avg;
                ++results.shortCount;
            } else {
                results.totalLong += avg;
                ++results.longCount;
            }
            results.count++;
        });

        results.average = results.count ? results.totalScore / results.count : 0;
        results.longAverage = results.longCount ? results.totalLong / results.longCount : 0;
        results.shortAverage = results.shortCount ? results.totalShort / results.shortCount : 0;
        results.weightedAverage = results.totalWeights ? results.totalWeightedScore / results.totalWeights : 0;
        results.averageZscore = zScoreCount ? results.totalZscore / zScoreCount : 0;
        results.liveVsBacktestAverage = liveVsBacktestCount ? totalLiveVsBacktest / liveVsBacktestCount : 0;
        results.live_vs_backtest = results.liveVsBacktestAverage;
        results.oosAverage = oosCount ? totalOos / oosCount : 0;
        results.paramSensAverage = paramSensCount ? totalParamSens / paramSensCount : 0;

        return [results];
    }

    function algoLinkFormatter(cell, row) {
        let algoid = row.algoId;
        return (
            <>
                <div className='sameline'>
                    <AlgoDrawer link={cell} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoid} role={props.role} />
                    &nbsp;<Tooltip width={'500px'} textClass="tooltip-link smaller-text" text="📊">
                        <SingleAlgoRobustness algoId={algoid} />
                    </Tooltip >
                    &nbsp;<AlgoStatsTooltip algoId={algoid} years={0} />
                    &nbsp;<AlgoQuickManage role={props.role} algoId={algoid} planId={props.planId} />
                </div>
            </>

        )
    }

    function liveVsBacktestFormatter(cell, row) {
        return <Tooltip width="600px" text={tableHelpers.intFormatter(cell, row)} json={row.details ? row.details.liveVsBacktest : null} />
    }
    function oosFormatter(cell, row) {
        return <Tooltip width="600px" text={tableHelpers.intFormatter(cell, row)} json={row.details ? row.details.oos : null} />
    }
    function monteCarloFormatter(cell, row) {
        return <Tooltip width="600px" text={tableHelpers.intFormatter(cell, row)} json={row.details ? row.details.monteCarlo : null} />
    }
    function parameterSensitivityFormatter(cell, row) {
        return <Tooltip width="600px" text={tableHelpers.intFormatter(cell, row)} json={row.details ? row.details.parameterSensitivity : null} />
    }
    function parameterCountFormatter(cell, row) {
        return <Tooltip width="600px" text={tableHelpers.intFormatter(cell, row)} json={row.details ? row.details.parameterCount : null} />
    }
    function universalnessFormatter(cell, row) {
        return <Tooltip width="600px" text={tableHelpers.intFormatter(cell, row)} json={row.details ? row.details.universalness : null} />
    }

    return (
        <>
            <br></br>

            <Link id="managealgos" className="bg-transparent" to={"/managealgos"}>Update Algos</Link>
            <br></br>
            <input type='checkbox' checked={showAll} onClick={() => setShowAll(!showAll)} />Show All Algos<br></br>

            <RichTable data={getStats()} className="table-striped table-hover table-condensed" mappers={[
                { title: 'Average', field: 'average', formatter: tableHelpers.percentFormatter },
                { title: 'Weighted Avg', field: 'weightedAverage', formatter: tableHelpers.percentFormatter },
                { title: 'Long Avg', field: 'longAverage', formatter: tableHelpers.percentFormatter },
                { title: 'Short Avg', field: 'shortAverage', formatter: tableHelpers.percentFormatter },
                { title: 'Live vs Backtest Avg', field: 'liveVsBacktestAverage', formatter: tableHelpers.percentFormatter },
                { title: 'OOS Avg', field: 'oosAverage', formatter: tableHelpers.percentFormatter },
                { title: 'Param Sens Avg', field: 'paramSensAverage', formatter: tableHelpers.percentFormatter },
            ]} />

            <RichTable data={getSccores()} className="table-striped table-hover table-condensed" mappers={[
                { title: 'Algo', field: 'display_name', formatter: algoLinkFormatter, sorters: true, filter: 'text' },
                { title: 'Symbol', field: 'trade_symbol', sorters: true, filter: 'text' },
                { title: 'Type', field: 'algo_type', sorters: true, filter: 'choice', hidden: props.mobileView },
                { title: 'Allocation', field: 'percentage', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                { title: 'Overall', field: 'overall', formatter: tableHelpers.decimalFormatter, sorters: true },
                { title: 'Average', field: 'average', formatter: tableHelpers.decimalFormatter, sorters: true },
                { title: 'Live Trades', field: 'live_vs_backtest', formatter: liveVsBacktestFormatter, sorters: true },
                { title: 'Out of Sample', field: 'oos', formatter: oosFormatter, sorters: true, hidden: props.mobileView },
                { title: 'Param. Sensitivity', field: 'parameter_sensitivity', formatter: parameterSensitivityFormatter, sorters: true, hidden: props.mobileView },
                { title: 'Univeralness', field: 'universalness', formatter: universalnessFormatter, sorters: true, hidden: props.mobileView },
                { title: 'Param. Count', field: 'parameter_count', formatter: parameterCountFormatter, sorters: true, hidden: props.mobileView },
                { title: 'Monte Carlo', field: 'monte_carlo', formatter: monteCarloFormatter, sorters: true, hidden: props.mobileView },
            ]} />

            <br></br>
            <br></br>
        </>
    );
}

export default AlgoRobustness;